import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOrderDetails } from "../../../api/order";

export const fetchOrders = createAsyncThunk("fetchOrder", async (payload) => {
  const res = await getOrderDetails(payload);
  return res;
});
const initialState = {};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export const { reset } = orderSlice.actions;
export { orderSlice };
